<div class="container-fluid">
  <div *ngIf="showMessage" class="container">
    <div class="box">
      <h2>{{mensagemPrincipal}}</h2>
      <p>{{mensagemAdicional}}</p>
    </div>

  </div>
</div>
